import React from "react";
import AdminGroupAccountCamperJoined from "./AdminGroupAccountCamperJoined";
import '../Styles/AdminGroupAccountCardList.scss';


const AdminGroupAccountCampersJoinedList = ({campersJoined}) => {
   console.log("Here's queried Account", campersJoined)
	return (
		<div className="AdminGroupAccountCardListLayout">
			{ campersJoined?.map((camperJoined) => <AdminGroupAccountCamperJoined 
         camperJoined={camperJoined}/>)}
		</div>	
	)
}

export default AdminGroupAccountCampersJoinedList;